export const OpenCellIconButtonVariants = {
	open: { rotate: 90 },
	close: { rotate: 0 }
}

export const getMissingChipsText = (chips) => chips.slice(2).join(', ');